export const SUPPORTED_LANGUAGES = [
  "en",
  "ja",
  "zh-Hans",
  "zh-Hant",
  "ko",
  "es",
  "fr",
  "de",
  "pt",
  "it",
  "ru",
  "ar",
  "hi",
  "id"
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export type LanguageSetting = "auto" | SupportedLanguage;

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return typeof value === "string" && SUPPORTED_LANGUAGES.includes(value as SupportedLanguage);
}

export function isLanguageSetting(value: unknown): value is LanguageSetting {
  return value === "auto" || isSupportedLanguage(value);
}
